$(document).ready(function () {
  $('#recently-viewed-products-grid, #recently-viewed-products-grid-mobileu').slick({
				infinite: false,
				slidesToShow: 6,
				slidesToScroll: 6,
				prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button"><i style="color:#000" class="fa fa-chevron-left" aria-hidden="true"></i></button>',
				nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button"><i style="color:#000" class="fa fa-chevron-right" aria-hidden="true"></i></button>',
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3,
						}
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
						}
					}
				]
		});
  $(document).on('click', "#hhkk", function () {
    //$("#header-search").toggle().toggleClass( "skip-active" );
    $(
      ".boost-pfs-search-suggestion-mobile-top-panel, .boost-pfs-search-suggestion-mobile-overlay"
    ).fadeIn();
  });
  $(".scroll_to_reviews").click(() => {
    var $container = $("html,body");
    var $scrollTo = $("#judgeme_product_reviews");
    $container.animate(
      {
        scrollTop: $scrollTo.offset().top,
        scrollLeft: 0,
      },
      1000
    );
  });
  $("a.afterpay-what-is-modal-trigger").fancybox({
      type: 'inline',
      hideOnContentClick: true
    });
  $("a.klarna-logo-link").fancybox({
      type: 'inline',
      hideOnContentClick: true
    });
  $("#askQues").fancybox({
    type: "inline",
    hideOnContentClick: true,
  });
  $(".appendform").append($(".pagecontactform"));
  $(".pagecontactform").removeClass("unloadform");
  if ($(window).width() < 768) {
    $(".footer__menu .footer__heading").click(function () {
      $(".footer-menu-arrow", this).toggleClass("rotated-arrow");
      $(this).parent().find("ul").stop().slideToggle("fast");
    });
    $(".footers__menu .footer__heading").click(function () {
      $(this).parent().find("ul").stop().slideToggle("fast");
      $(".footer-menu-arrow", this).toggleClass("rotated-arrow");
    });
  }
  if ($(window).width() > 501) {
    $(".product-carousel-mobile .recently-viewed-wrapper").html();
  } else {
    $(".tabcontent-cus .recently-viewed-wrapper").html();
  }
  $(".brands-index-item").click(function (e) {
    var id = $(this).data("id");
    $("body,html").animate(
      {
        scrollTop: $("#" + id).offset().top - 40,
      },
      0 //speed
    );
  });
  $(".menutoggleicon").click(function () {
    //$(this).parent().find("ul").stop().slideToggle('fast');
    $(".er-mobile-menu-wrapper").slideToggle();
  });
  $(".er-mobile-menu-wrapper .sub-menu").hide();
  $(
    ".er-mobile-menu-wrapper .more.arrow, .er-mobile-menu-wrapper .more.submenu-arrow"
  ).on("click", function () {
    $('.new_cart_coll .product_list').slick('refresh');
    $(this).parent().toggleClass("active");
    $(this).nextAll("ul").slideToggle("fast");
  });

  function cartSlideoutHeight() {
    var cartTitleHeight = $(".cart-slideout-title").outerHeight();
    var cartBottomHeight = $(".cart-slideout-bottom").outerHeight();
    var cartHeight = $("#header-cart").outerHeight();
    $(".cart-item-container").height(
      cartHeight - cartBottomHeight - cartTitleHeight + "px"
    );
  }

  function carUpdateContent(cart, key, value) {
    $.each(cart.items, function (index, item) {
      var itemWrapper = $('.cart-item-wrapper[data-key="' + item.key + '"]');
      if (itemWrapper.find(".cart-item-content .price .sale-price").length) {
        var comparePrice = itemWrapper
          .find(".cart-item-content .price .sale-price")
          .data("compare");
        itemWrapper
          .find(".cart-item-content .price .sale-price")
          .html(Shopify.formatMoney(comparePrice * item.quantity, ""));
      }
      itemWrapper
        .find(".cart-item-content .price .regular-price")
        .html(Shopify.formatMoney(item.final_line_price, ""));
      itemWrapper
        .find(".cart-item-content .cart-item-quantity")
        .val(item.quantity);
      itemWrapper.find(".all-in-stock").remove();
      if (item.quantity != value && item.key == key) {
        $(
          '<span class="all-in-stock" style="color:red;">There is only ' +
            item.quantity +
            " in stock</span>"
        ).insertAfter(
          itemWrapper.find(".cart-item-content .quantity-input-wrapper")
        );
      }

      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/products/" + item.handle + ".js",
        error: function (jqXHR, textStatus, errorThrown) {
          itemWrapper.find(".soldout-item").remove();
          $(
            '<span class="soldout-item" style="color:red;">SOLD OUT</span>'
          ).insertAfter(itemWrapper.find(".product-cart-actions"));
        },
        success: function (product) {
          console.log(product);
          itemWrapper.find(".soldout-item").remove();
        },
      });
    });

    // CD CODE
    var divide_price = cart.total_price / 100;
    $('.sweettooth-points-balances').html(Math.floor(divide_price))
    
    $(
      ".cart-forms-wrapper .cart-totals-container .cart-totals-wrapper .cart-subtotal-wrapper .cart-subtotal-value"
    ).html(Shopify.formatMoney(cart.total_price, ""));
    if (cart.item_count == 0) {
      $(".cartform-empty").show();
      $(".cartform-content").hide();

      $(".minicart-wrapper .empty-cart").show();
      $(".minicart-wrapper .cart-slideout-bottom").hide();
      $(".minicart-wrapper .cart-item-container").hide();
    }

    var freeShippingThreshold = parseInt($('body').attr('data-freeshipping')) * 100;
    if (cart.total_price > freeShippingThreshold) {
      $(".freeship-wrapper").show();
      $(".freeship-wrapper").find(".need-more").hide();
      $(".freeship-wrapper").find(".eligible").show();
    } else {
      $(".freeship-wrapper").show();
      $(".freeship-wrapper").find(".need-more").show();
      $(".freeship-wrapper").find(".eligible").hide();
      $(".freeship-away-amount").html(
        Shopify.formatMoney(freeShippingThreshold - cart.total_price, "")
      );
    }
    $(".header-cart__count").html(cart.item_count);

    // CD Arshit
    $('.new_cart_coll .product_list').slick('refresh');
    if(cart.item_count == 0){
      $('.new_section_added').addClass('empty_cart');
    }else{
      $('.new_section_added').removeClass('empty_cart');
    }
    
  }
  $.getJSON("/cart.js", function (cart) {
    var freeShippingThreshold = parseInt($('body').attr('data-freeshipping')) * 100;
    //console.log(cart);
    //console.log(freeShippingThreshold);
    if (cart.total_price > freeShippingThreshold) {
      $(".freeship-wrapper").show();
      $(".freeship-wrapper").find(".need-more").hide();
      $(".freeship-wrapper").find(".eligible").show();
    } else {
      $(".freeship-wrapper").show();
      $(".freeship-wrapper").find(".need-more").show();
      $(".freeship-wrapper").find(".eligible").hide();
      $(".freeship-away-amount").html(
        Shopify.formatMoney(freeShippingThreshold - cart.total_price, "")
      );
    }
    //cartSlideoutHeight();

    $.each(cart.items, function (index, item) {
      var itemWrapper = $('.cart-item-wrapper[data-key="' + item.key + '"]');
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/products/" + item.handle + ".js",
        error: function (jqXHR, textStatus, errorThrown) {
          itemWrapper.find(".soldout-item").remove();
          $(
            '<span class="soldout-item" style="color:red;">SOLD OUT</span>'
          ).insertAfter(itemWrapper.find(".product-cart-actions"));
        },
        success: function (product) {
          //console.log(product);
          itemWrapper.find(".soldout-item").remove();
        },
      });
    });
  });
  $(".quantity-input-wrappers").each(function () {
    if ($(this).hasClass("js-added")) return;
    $(this).prepend(
      '<span class="js-quantity-input js-quantity-decrease">-</span>'
    );
    $(this).append(
      '<span class="js-quantity-input js-quantity-increase">+</span>'
    );
    $(this).addClass("js-added");
  });
  $(document).on("click", ".js-quantity-decreases", function (e) {
    var value = parseInt($(this).siblings("input").val());
    $(this)
      .siblings("input")
      .val(value - 1 < 0 ? 0 : value - 1);
    $(this).siblings("input").trigger("change");
  });
  $(document).on("click", ".js-quantity-increases", function (e) {
    var value = parseInt($(this).siblings("input").val());
    $(this)
      .siblings("input")
      .val(value + 1);
    $(this).siblings("input").trigger("change");
  });
  $(document).on("change", ".cart-item-quantity", function () {
    var key = $(this).data("key");
    var value = $(this).val();
    var params = {
      type: "POST",
      url: "/cart/change.js",
      data: {
        id: key,
        quantity: $(this).val(),
      },
      dataType: "json",
      beforeSend: function () {
        //console.log(key);
        if (parseInt(value) == 0) {
          $('.cart-item-wrapper[data-key="' + key + '"]').remove();
        }
      },
      success: function (cart) {
        //console.log(cart);
        carUpdateContent(cart, key, value);

        // CD CODE
        var data_price_total = 0
        $('.cart-item-container  .cart-item-wrapper').each(function( index ) {
          if($(this).find('.price .sale-price').attr('data-compare') != null){
            data_price_total = data_price_total + parseInt($(this).find('.price .sale-price').attr('data-compare'));
          }else{
            data_price_total = data_price_total + parseInt($(this).find('.price .regular-price').attr('data-price'));
          }
        })
        if(data_price_total > cart.total_price){
          $('.minicart-wrapper .cart-subtotal-value').html('<span class="compare_total_price">'+ Shopify.formatMoney(data_price_total, "") +'</span>' + Shopify.formatMoney(cart.total_price, ""))
        }else{
          $('.minicart-wrapper .cart-subtotal-value').html(Shopify.formatMoney(cart.total_price, ""));
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        //console.log(textStatus);
        //console.log(XMLHttpRequest.responseText);
      },
      complete: function (jqxhr, text) {
        //console.log(text);
        //console.log(jqxhr);
      },
    };
    jQuery.ajax(params);
  });

  $(document).on(
    "click",
    ".cart-item-wrapper .remove .btn-remove",
    function (e) {
      e.preventDefault();
      var itemWrapper = $(this).closest(".cart-item-wrapper");
      itemWrapper.find(".cart-item-quantity").val(0).trigger("change");
    }
  );
  $("#cart-header").click(function (e) {
    e.preventDefault();
    if ($(window).outerWidth() < 768) {
      e.preventDefault();
      location.href = "/cart";
    } else {
      $('.new_cart_coll .product_list').slick('refresh');
      $("#header-cart").toggleClass("active");
    }
  });

  $("#cart-close").click(function (e) {
    e.preventDefault();
    $('.new_cart_coll .product_list').slick('refresh');
    $("#header-cart").toggleClass("active");
  });

  $("body").on("click", ".proitem-cart-btn", function () {
    var variantCount = $(this).data("variant-count");
    var productId = $(this).data("product");
    var variantId = $(this).data("variant");
    var url = $(this).data("url");

    if($('#header-cart.active').length){
      $('.new_cart_coll .product_list').slick('refresh');
      $('.desktop-nav-cart').trigger('click');
    }
    
    // if (variantCount != 1) {
    //   location.href = url;
    //   return 0;
    // } else {
    // }

    params = {
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: 1,
        id: variantId,
      },
      dataType: "json",
      beforeSend: function (jqxhr, settings) {
        //$body.trigger('beforeAddItem.ajaxCart', form);
      },
      success: function (line_item) {
        //console.log(line_item);
        if ($(window).outerWidth() < 768) {
          location.href = "/cart";
        } else {
        }
        $.getJSON("/cart.js", function (cart) {
          //console.log(cart);
          //console.log('There are now ' + cart.item_count + ' items in the cart');
          //$('.hide-empty-cart').show();
          //$("#cart-sidebar").html(' ');
          $(".cart-item-container").html(" ");
          $.each(cart.items, function (index, item) {
            //console.log(item);
            var cartItemTemplate = $('.cart-item-html').html();
            var itemHtml = cartItemTemplate;//cartItemTemplate.html
            itemHtml = itemHtml.replace(/{{itemKey}}/g, item.key);
            itemHtml = itemHtml.replace(/{{itemUrl}}/g, item.url);
            itemHtml = itemHtml.replace(/{{itemImage}}/g, item.image);
            itemHtml = itemHtml.replace(/{{itemQuantity}}/g, item.quantity);
            itemHtml = itemHtml.replace(/{{itemTitle}}/g, item.product_title);
            itemHtml = itemHtml.replace(/{{itemSku}}/g, item.sku);
            if (item.variant_title !== null) {
              itemHtml = itemHtml.replace(
                /{{itemSize}}/g,
                '<span class="variant_title"><span>Size: </span>' +
                  item.variant_title +
                  "</span>"
              );
            } else {
              itemHtml = itemHtml.replace(/{{itemSize}}/g, "");
            }

            itemHtml = itemHtml.replace(
              /{{itemPrice}}/g,
              '<span class="regular-price" data-price="' +
                item.price +
                '">' +
                Shopify.formatMoney(item.final_line_price, "") +
                "<span>"
            );
            itemHtml = itemHtml.replace(/{{itemId}}/g, item.product_id);
            $(".cart-item-container").append(itemHtml);
            var itemWrapper = $(
              '.cart-item-wrapper[data-key="' + item.key + '"]'
            );
            $.ajax({
              type: "GET",
              dataType: "json",
              url: "/products/" + item.handle + ".js",
              error: function (jqXHR, textStatus, errorThrown) {},
              success: function (product) {
                //console.log(product);
                if (product.compare_at_price > product.price) {
                  itemWrapper
                    .find(".price")
                    .prepend(
                      '<span class="sale-price" data-compare="' +
                        product.compare_at_price +
                        '">' +
                        Shopify.formatMoney(
                          product.compare_at_price * item.quantity,
                          ""
                        ) +
                        "</span>"
                    );
                }
              },
            });
          });
          $(
            ".cart-forms-wrapper .cart-totals-container .cart-totals-wrapper .cart-subtotal-wrapper .cart-subtotal-value"
          ).html(Shopify.formatMoney(cart.total_price, ""));

          var freeShippingThreshold = parseInt($('body').attr('data-freeshipping')) * 100;
          if (cart.total_price > freeShippingThreshold) {
            $(".freeship-wrapper").show();
            $(".freeship-wrapper").find(".need-more").hide();
            $(".freeship-wrapper").find(".eligible").show();
          } else {
            $(".freeship-wrapper").show();
            $(".freeship-wrapper").find(".need-more").show();
            $(".freeship-wrapper").find(".eligible").hide();
            $(".freeship-away-amount").html(
              Shopify.formatMoney(freeShippingThreshold - cart.total_price, "")
            );
          }

          $(".quantity-input-wrapper").each(function () {
            if ($(this).hasClass("js-added")) return;
            $(this).prepend(
              '<span class="js-quantity-input js-quantity-decrease">-</span>'
            );
            $(this).append(
              '<span class="js-quantity-input js-quantity-increase">+</span>'
            );
            $(this).addClass("js-added");
          });

          // var cartTitleHeight = $(".cart-slideout-title").outerHeight();
          // var cartBottomHeight = $(".cart-slideout-bottom").outerHeight();
          // var cartHeight = $("#header-cart").outerHeight();
          // $(".cart-item-container").height(
          //   cartHeight - cartBottomHeight - cartTitleHeight + "px"
          // );

          $(".minicart-wrapper .empty-cart").hide();
          $(".minicart-wrapper .cart-slideout-bottom").show();
          $(".minicart-wrapper .cart-item-container").show();
          $(".header-cart__count").html(cart.item_count);

          $("#header-cart").toggleClass("active");

          // CD Arshit
          $('.new_cart_coll .product_list').slick('refresh');
          if(cart.item_count == 0){
            $('.new_section_added').addClass('empty_cart');
          }else{
            $('.new_section_added').removeClass('empty_cart');
          }
          
        });
      },
    };
    $.ajax(params);
  });
});
function ShowTime() {
  var now = new Date().toLocaleString("en-US", {
    timeZone: "Australia/Brisbane",
  });
  var nowAus = new Date(now);
  // year as (YYYY) format
  var year = nowAus.getFullYear();

  // month as (MM) format
  var month = ("0" + (nowAus.getMonth() + 1)).slice(-2);

  // date as (DD) format
  var date = ("0" + nowAus.getDate()).slice(-2);
  var teme = ("0" + nowAus.getHours()).slice(-2);
  var Minutes = ("0" + nowAus.getMinutes()).slice(-2);
  var Seconds = ("0" + nowAus.getSeconds()).slice(-2);
  // date time in YYYY-MM-DD format
  var formattedDate = year + "-" + month + "-" + date;
  //var formattedDate = nowAus.format('YYYY-MM-DD');
  var exemptList = [];
  //var teme = hours;
  //alert(now);
  if (teme < 14) {
    var hrs = 13 - teme;
  } else {
    var hrs = 24 + (13 - teme);
  }

  if (date == 5) {
    if (teme < 14) {
      hrs;
    } else {
      var hrs = hrs + 48;
    }
  } else if (date == 6) {
    var hrs = hrs + 24;
  } else if (date == 0) {
    var hrs = 24 + (12 - teme);
  }

  // Is date today in the exempt list?
  while ($.inArray(formattedDate, exemptList) !== -1) {
    if (nowAus != 6 || nowAus != 7) {
      // if date is saturday or sunday
      hrs = hrs + 24;
    }
    formattedDate = nowAus.add(1, "days").format("YYYY-MM-DD");
  }

  var mins = 59 - Minutes;
  var secs = 60 - Seconds;

  $(".countdown_hours").html(hrs);
  $(".countdown_minutes").html(mins);
  $(".countdown_seconds").html(secs);
}

var countdown;
function StopTime() {
  clearInterval(countdown);
}
setInterval(ShowTime, 1000);
function removeProduct(key) {
// CD shubham
  // var confirmAction = confirm("Remove product from cart?");
    // if (confirmAction) {
        $("div[data-key='"+key+"'] .hidden-remove a").click();
    // }
}
window.onload = function () {

  jQuery(function ($) {
    var offset = 300;
    var duration = 500;
    $(window).scroll(function () {
      if ($(this).scrollTop() > offset) {
        $(".back-to-top").fadeIn(duration);
      } else {
        $(".back-to-top").fadeOut(duration);
      }
    });
    $(".back-to-top")
      .unbind("click.smoothscroll")
      .bind("click", function (e) {
        e.preventDefault();
        $("html, body").animate({ scrollTop: 0 }, duration);
        return false;
      });
  });
};

// CD Arshit
$(document).ready(function () {
  if($(".new_cart_coll .product_list").length){
    $('.new_cart_coll .product_list').each(function(slider___slider) {
      $(this).slick({
        dots: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: $(this).parent().find('.slider_arrow_left'),
        nextArrow: $(this).parent().find('.slider_arrow_right')
      });
    });
  }

  $(document).on('click', '.new_cart_coll .js_atc_btn', function(){
    var _this = $(this),
        variant_id = $(_this).parents('.product_block').attr('variant_id');
    $(_this).addClass('disabled');
    
    params = {
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: 1,
        id: variant_id,
      },
      dataType: "json",
      beforeSend: function (jqxhr, settings) {
        //$body.trigger('beforeAddItem.ajaxCart', form);
      },
      success: function (line_item) {
        $(_this).removeClass('disabled');
        
        if ($(window).outerWidth() < 768) {
          location.href = "/cart";
        }
        $.getJSON("/cart.js", function (cart) {
          $(".cart-item-container").html(" ");
          $.each(cart.items, function (index, item) {
            var cartItemTemplate = $('.cart-item-html').html();
            var itemHtml = cartItemTemplate;//cartItemTemplate.html
            itemHtml = itemHtml.replace(/{{itemKey}}/g, item.key);
            itemHtml = itemHtml.replace(/{{itemUrl}}/g, item.url);
            itemHtml = itemHtml.replace(/{{itemImage}}/g, item.image);
            itemHtml = itemHtml.replace(/{{itemQuantity}}/g, item.quantity);
            itemHtml = itemHtml.replace(/{{itemTitle}}/g, item.product_title);
            itemHtml = itemHtml.replace(/{{itemSku}}/g, item.sku);
            if (item.variant_title !== null) {
              itemHtml = itemHtml.replace(
                /{{itemSize}}/g,
                '<span class="variant_title"><span>Size: </span>' +
                  item.variant_title +
                  "</span>"
              );
            } else {
              itemHtml = itemHtml.replace(/{{itemSize}}/g, "");
            }

            itemHtml = itemHtml.replace(
              /{{itemPrice}}/g,
              '<span class="regular-price" data-price="' +
                item.price +
                '">' +
                Shopify.formatMoney(item.final_line_price, "") +
                "<span>"
            );
            itemHtml = itemHtml.replace(/{{itemId}}/g, item.product_id);
            $(".cart-item-container").append(itemHtml);
            var itemWrapper = $(
              '.cart-item-wrapper[data-key="' + item.key + '"]'
            );
            $.ajax({
              type: "GET",
              dataType: "json",
              url: "/products/" + item.handle + ".js",
              error: function (jqXHR, textStatus, errorThrown) {},
              success: function (product) {
                if (product.compare_at_price > product.price) {
                  itemWrapper
                    .find(".price")
                    .prepend(
                      '<span class="sale-price" data-compare="' +
                        product.compare_at_price +
                        '">' +
                        Shopify.formatMoney(
                          product.compare_at_price * item.quantity,
                          ""
                        ) +
                        "</span>"
                    );
                }
              },
            });
          });
          $(
            ".cart-forms-wrapper .cart-totals-container .cart-totals-wrapper .cart-subtotal-wrapper .cart-subtotal-value"
          ).html(Shopify.formatMoney(cart.total_price, ""));

          var freeShippingThreshold = parseInt($('body').attr('data-freeshipping')) * 100;
          if (cart.total_price > freeShippingThreshold) {
            $(".freeship-wrapper").show();
            $(".freeship-wrapper").find(".need-more").hide();
            $(".freeship-wrapper").find(".eligible").show();
          } else {
            $(".freeship-wrapper").show();
            $(".freeship-wrapper").find(".need-more").show();
            $(".freeship-wrapper").find(".eligible").hide();
            $(".freeship-away-amount").html(
              Shopify.formatMoney(freeShippingThreshold - cart.total_price, "")
            );
          }

          $(".quantity-input-wrapper").each(function () {
            if ($(this).hasClass("js-added")) return;
            $(this).prepend(
              '<span class="js-quantity-input js-quantity-decrease">-</span>'
            );
            $(this).append(
              '<span class="js-quantity-input js-quantity-increase">+</span>'
            );
            $(this).addClass("js-added");
          });

          $(".minicart-wrapper .empty-cart").hide();
          $(".minicart-wrapper .cart-slideout-bottom").show();
          $(".minicart-wrapper .cart-item-container").show();
          $(".header-cart__count").html(cart.item_count);
          
          $('.new_cart_coll .product_list').slick('refresh');
          if(cart.item_count == 0){
            $('.new_section_added').addClass('empty_cart');
          }else{
            $('.new_section_added').removeClass('empty_cart');
          }
          
        });
      },
    };
    $.ajax(params);
  });
  
});

// CD shubham
$(document).ready(function(){
  if ($(".checkout-information a[title='#click-drigger']").length) {
      $(".checkout-information a[title='#click-drigger']").click(function(){
                $('iframe').contents().find('.chat-toggle').click();
          });
 
  }
});

if ($("#rewards_popup").length) {
$("#rewards_popup").click(function(){
    $('iframe').contents().find('.launcher-button').click();
});
}

// CD Dev
$(document).ready(function(){
 $(".icon_zoom").on("click", function(){
   console.log("call");
   // $('.product-gallery__image .product-gallery__link').trigger('click')
   $(this).parents('.image_with_zoom_icon').find('a').trigger('click')
 });
})

// cd jaydip

$(document).on("click",".readmore-short-desp-desktop",function() {
    event.preventDefault()
  $(this).parent().toggleClass("active");
    if($(this).parent().hasClass('active')){
      $(this).text("<< Read Less");
    }else{
      $(this).text("Read more >>");
    }
});

